// extracted by css-extract-rspack-plugin
module.exports =  {"latex-input":"LatexEditor-JRkM__latex-input"};